import getConfig from 'next/config';
import _ from 'lodash';
import axios from 'axios';

const { publicRuntimeConfig } = getConfig();
const word_press_url = publicRuntimeConfig.HOMII_WORDPRESS_URL;
const blogPaginationSize = publicRuntimeConfig.DEFAULT_BLOG_PAGINATION_PAGE_SIZE;

async function RetrieveWordPressPage(page_name) {
    const response = await axios.get(`${word_press_url}/home_page`, {
        params: {
            slug: `${page_name}`,
            _fields: 'acf',
            acf_format: 'standard',
        },
    });
    return _.get(response, 'data[0]');
}

async function RetrieveWordPressPost(slug) {
    const response = await axios.get(`${word_press_url}/blog_posts`, {
        params: {
            _fields: 'acf',
            acf_format: 'standard',
            slug: `${slug}`,
        },
    });
    return _.get(response, 'data[0]');
}

async function ListWordPressBlogTags() {
    const response = await axios.get(`${word_press_url}/tags`);
    return _.get(response, 'data');
}

async function ListWordPressBlogPosts(page_size, page, filter) {   

    let params = filter === null ?
    {                  
        _fields: 'acf',
        acf_format: 'standard',
        per_page: page_size,
        page: page
    }
    :
    {
        _fields: 'acf',
        acf_format: 'standard',
        tags: filter       
    }

    const response = await axios.get(`${word_press_url}/blog_posts`, {
        params: params,
    });

    const count = parseInt(response.headers['x-wp-total']);

    if(count <= 0) {
        return {
            blogs: [],
            meta: {
                next_page: 0,
                previous_page: 0,
                count: count,
            },
        };         
    }
    
    if(filter !== null) {
        return {
            blogs: _.get(response, 'data'),
            meta: {
                next_page: 1,
                previous_page: 1,
                count: 0,
            },
        };        
    }

    const pageCount = Math.ceil(count / blogPaginationSize);    

    let next_page = page !== pageCount ? page + 1 : page;
    let previous_page = page - 1;
    
    const data = {
        blogs: _.get(response, 'data'),
        meta: {
            next_page: next_page,
            previous_page: previous_page,
            count: count,
        },
    };    

    return data;
    
}

async function RetrieveWordPressMedia(id) {
    if (!id) return null;
    try {
        const response = await axios.get(`${word_press_url}/media/${id}`);
        return _.get(response, 'data.source_url', null);
    } catch {
        return null;
    }
}

export default {
    RetrieveWordPressPage,
    RetrieveWordPressPost,
    RetrieveWordPressMedia,
    ListWordPressBlogTags,
    ListWordPressBlogPosts,
};
